<template>
  <v-row>
    <v-card
      v-if="!editMode"
      class="mx-2 mb-2 resize-cursor"
      width="100%"
    >
      <DocumentBlockViewerActions
        v-if="value.needConfirm"
        :value="value"
        @apply="
          (versionId) => {
            $emit('apply', versionId);
          }
        "
        @decline="
          (versionId) => {
            $emit('decline', versionId);
          }
        "
      />
      <v-hover v-slot="{ hover }">
        <v-col>
          <v-card-text
            class="pa-0"
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover, 'hover-block': true }"
          >
            <div
              class="pa-2 document-block"
              v-html="value.content"
            />
            <v-chip
              v-for="tag in value.tags"
              :key="tag.id"
              label
              outlined
              small
              class="mx-1"
            >
              {{ tag.title }}
            </v-chip>
          </v-card-text>

          <v-card-actions class="justify-center">
            <HoverBtn
              :hover="hover"
              icon="edit"
              @handler="editMode = true"
            />
            <HoverBtn
              :hover="hover"
              icon="delete"
              @handler="actionDialog = true"
            />
            <DropdownMenuHover
              :hover="hover"
              icon="add"
              @edit="
                (val) => {
                  $emit('edit', val);
                }
              "
              @add="
                (val) => {
                  $emit('add', val);
                }
              "
            />
          </v-card-actions>
        </v-col>
      </v-hover>
    </v-card>

    <DocumentBlock
      v-else
      :id="value.id"
      :modal="true"
      @add="updateBlock"
      @update="
        (val) => {
          updateVersionBlock(val);
        }
      "
      @close="editMode = false"
    />
    <Confirm
      :value="actionDialog"
      text="Ви дійсно хочете видалити блок?"
      @cancel="actionDialog = false"
      @confirm="remove"
    />
  </v-row>
</template>
<script>
import HoverBtn from "../../components/HoverBtn.vue";
import Confirm from "../../components/Confirm.vue";
import DocumentBlockViewerActions from "../documents/DocumentBlockViewerActions.vue";
import DropdownMenuHover from "./DropdownMenuHover.vue";
import DocumentBlock from "./DocumentBlock.vue";

export default {
  components: {
    HoverBtn,
    Confirm,
    DocumentBlockViewerActions,
    DropdownMenuHover,
    DocumentBlock,
  },
  props: ["value"],
  data() {
    return {
      actionDialog: false,
      editMode: false,
    };
  },
  methods: {
    remove() {
      this.$emit("delete");
      this.actionDialog = false;
    },
    updateBlock() {
      this.$emit("add");
      this.editMode = false;
    },
    updateVersionBlock(val) {
      this.$emit("apply", val);
      this.editMode = false;
    },
  },
};
</script>
<style>
.v-card-text {
  transition: all 0.4s ease-in-out;
}

.v-card-text:hover {
  opacity: 0.8;
  color: #e57373 !important;
}

.show-btn {
  color: #e57373 !important;
}

.document-block img {
  max-width: 100%;
}
</style>
